import { NgModule } from '@angular/core';
import { quickOrderTranslationChunksConfig, quickOrderTranslationsEn } from '@spartacus/cart/quick-order/assets';
import { CART_QUICK_ORDER_FEATURE, QuickOrderRootModule } from '@spartacus/cart/quick-order/root';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
import { NDBSQuickOrderModule } from './quick-order/ndbs-quick-order.module';
import { ImportProductsFromCsvService } from '@spartacus/cart/import-export/components';
import { CustomImportProductsFromCsvService } from './import-export/core/import-products-from-csv.service';

@NgModule({
  declarations: [],
  imports: [QuickOrderRootModule, NDBSQuickOrderModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [CART_QUICK_ORDER_FEATURE]: {
          // module: () => import('@spartacus/cart/quick-order').then(m => m.QuickOrderModule),
          module: () => import('./quick-order/ndbs-quick-order.module').then(m => m.NDBSQuickOrderModule),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: { en: quickOrderTranslationsEn },
        chunks: quickOrderTranslationChunksConfig,
      },
    }),
    {
      provide: ImportProductsFromCsvService,
      useClass: CustomImportProductsFromCsvService,
    },
  ],
})
export class CartQuickOrderFeatureModule {}
